import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, umsUrl } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_DETAILS, GET_VENDOR_DETAILS_SUCCESS, GET_VENDOR_DETAILS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getVendorDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/vendors/${payload?.urlParam?.vendorId}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      const errMsg = response?.response?.data?.message || 'Failed to fetch vendor details';
      cogoToast.error(errMsg);
      yield put({
        type: GET_VENDOR_DETAILS_ERROR,
        payload: errMsg,
      });
    }
  } catch (error) {
    cogoToast.error('Failed to fetch vendor details');
    yield put({ type: GET_VENDOR_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetVendorDetails() {
  yield takeEvery(GET_VENDOR_DETAILS, getVendorDetails);
}

function* getVendorDetailsSaga() {
  yield all([fork(watchGetVendorDetails)]);
}

export default getVendorDetailsSaga;
